import { Button, FormGroup, Modal, TextInput } from '@ksyos/design-system';
import React, { useState } from 'react';
import type { FundingErrorInformation } from '@common/enums/fundingErrorInformation';
import type { ValidationErrors } from '@frontend/utils';
import { getSelectedLanguage } from '@frontend/translate';
import { emptyValidationErrors, getValidationErrorTranslation, updateValidationErrorsForOne } from '@frontend/utils';
import { fundingErrorInformationValidationSchema } from './financingValidation';

type OtherFundingErrorInformationModalProps = {
    onClose: () => void;
    onUpdateFundingErrorInformation: (fundingErrorInfo: FundingErrorInformation) => Promise<void>;
    showOtherFundingErrorInformationModal: boolean;
};

export function OtherFundingErrorInformationModal(props: OtherFundingErrorInformationModalProps) {
    const language = getSelectedLanguage();
    const [errors, setErrors] = useState<ValidationErrors>(emptyValidationErrors);
    const [fundingErrorInformation, setFundingErrorInformation] = useState<FundingErrorInformation>();

    return (
        <Modal
            isOpen={props.showOtherFundingErrorInformationModal}
            onClose={() => props.onClose()}
        >
            <React.Fragment key=".0">
                <Modal.Header>{language.request.fundingErrorInformation}</Modal.Header>
                <Modal.CloseButton />
                <Modal.Body>
                    <FormGroup
                        hasErrors={errors.has('fundingErrorInformation')}
                        label={language.request.fundingErrorInformation}
                    >
                        <TextInput
                            error={getValidationErrorTranslation(errors.get('fundingErrorInformation'))}
                            onChange={(event) => {
                                if (event.target.value === '') {
                                    return;
                                }
                                setFundingErrorInformation(event.target.value as FundingErrorInformation);
                                validateFundingErrorInformation(event.target.value);
                            }}
                            placeholder={language.request.fundingErrorInformation}
                            value={fundingErrorInformation || ''}
                        />
                    </FormGroup>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        key={1}
                        onClick={() => {
                            setFundingErrorInformation(undefined);
                            setErrors(emptyValidationErrors);
                            props.onClose();
                        }}
                        variant="outline"
                    >
                        {language.common.cancel}
                    </Button>
                    <Button
                        isDisabled={!fundingErrorInformation || !errors.isEmpty()}
                        key={2}
                        onClick={() => {
                            if (!fundingErrorInformation) {
                                return;
                            }
                            props.onUpdateFundingErrorInformation(fundingErrorInformation);
                            props.onClose();
                        }}
                    >
                        {language.common.save}
                    </Button>
                </Modal.Footer>
            </React.Fragment>
        </Modal>
    );

    function validateFundingErrorInformation(value: string | null) {
        const newErrors = updateValidationErrorsForOne(
            fundingErrorInformationValidationSchema,
            { fundingErrorInformation: value },
            errors,
            'fundingErrorInformation'
        );
        setErrors(newErrors);
    }
}
